module.exports = __webpack_public_path__ + "img/Mada_Logo.abfd3997.svg";